import React from 'react';
import { Navigate } from 'react-router-dom';
import appSettings from '../appSettings';
import LegacyHome from '../legacy/LegacyHome';

interface EntryRouteProps {
  /** First beta page the user is authorized for, if any. */
  betaPath?: string;
}

export const AccessRestricted: React.FC = () => (
  <div className="access-denied">
    <h1>Access Restricted</h1>
    <p>Please contact the ITS Service Desk for assistance</p>
  </div>
);

/**
 * Decides which UI a user lands on. The Harness/Split beta flag is the only switch:
 * - Users with beta access always get the beta UI.
 * - Everyone else gets the Classic UI (or Access Restricted once legacy is disabled).
 */
const EntryRoute: React.FC<EntryRouteProps> = ({ betaPath }) => {
  if (betaPath) {
    return <Navigate to={betaPath} replace />;
  }

  if (!appSettings.LEGACY_UI_ENABLED) return <AccessRestricted />;

  return <LegacyHome />;
};

export default EntryRoute;
